export default {
  app: {
    translations: "translations/",
    menu: "menu/menu-item/?menu_type=menu",
    menuProfile: "menu/menu-item/?menu_type=profile",
    auth: {
      login: "auth/login/",
      otpRegister: "auth/otp-register/",
      otpRequest: "auth/otp-request/",
      socialLogin: "auth/social_login/",
      socialRegister: "auth/social_register/",
      google: "auth/google/",
      googleV2Login: "auth/google/v2/login/",
      googleV2Register: "auth/google/v2/register/",
      user: "auth/me/",
      resetPassword: "auth/reset_password/",
      setPassword: "auth/set_password/",
      sendValidationEmail: "auth/send_validation_email/",
      setLocale: "auth/language/:locale/",
      editUserData: "auth/edit/",
      markets: "auth/user_preference/enabled_markets/",
      loginToken: "auth/get_login_token/",
      userMessages: "auth/user-messages/",
      skipUserMessage: "auth/user-messages/:messageId/skip",
      acceptUserMessage: "auth/user-messages/:messageId/accept",
      delete: "auth/delete/",
      unsubscribe: {
        electronicCommunication:
          "auth/disable_flag/electronic_communication/:userId/:hash",
        marketingEmail: "auth/disable_flag/marketing_emails/:userId/:hash"
      }
    },
    invoices: {
      invoiceData: "invoices/invoice-data/",
      invoiceCountries: "invoices/invoice-countries/",
      companyData: "invoices/get-invoice-data-by-nip/?nip=:nip",
      invoicesList: "invoices/invoices/?limit=:limit&offset=:offset",
      createInvoice: "invoices/create-invoice/"
    },
    notification: {
      browser: "notifications/notifications_browser/:lastId",
      read_all: "notifications/read_all_notifications/",
      read_all_by_type: "notifications/read_all_notifications/:query",
      read: "notifications/read_notification/:id",
      unsubscribe: {
        notificationType:
          "notifications/subscription_status/:notificationType/:notificationChannel/:userId/:hash?status=remove"
      }
    },
    pushNotifications: {
      ios: "notifications/apn_status",
      android: "notifications/gcm_status"
    },
    stock: {
      search: "stock/search/:phrase",
      paginatedSearch: "stock/paginated-search/:phrase?limit=:limit",
      fastSearch: "stock/fast-search/:phrase?limit=:limit",
      item: "stock/get/:id",
      list: "stock/list/",
      analysisCategories: "stock/stock-analysis-categories/",
      insiderAnalysisCategories: "stock/insider-analysis-categories/",
      aiAnalysis: "stock/ai-analysis/:market/:ticker/?type=:type",
      aiAnalysisRetry:
        "stock/ai-analysis/:market/:ticker/?type=:type&retry=true"
    },
    stocks: {
      follow: "squaber/follow/",
      unfollow: "squaber/follow/:stockId",
      vote: "stock/vote/:stockId",
      toggleVote: "stock/vote/:stockId/toggle",
      bulkFollowUnfollow: "squaber/alert-many",
      toggleAlert: "squaber/alert/:stockId",
      singleStock: "squaber/:marketId/:stockId/?optimized=6",
      recommended: "squaber/has-recommended/",
      recommendations:
        "financial_report/recommendations/:stockId/:count/:start",
      mediaMonitor: "media_monitor/:market/:ticker/?limit=:count&offset=:start",
      mediaMonitorForChart:
        "media_monitor/:market/:ticker/?ts_start=:from&ts_stop=:to",
      singleMediaMonitor: "media_monitor/:mediaMonitorId",
      chartData:
        "squaber/chart_data/:stockId/:interval/?ts_start=:from&ts_stop=:to",
      chartDataCountBack: "squaber/chart_data/:stockId/:interval/?count=:count",
      lastMinMaxPoints:
        "squaber/chart-data/last-min-max-points/:stockId/?interval_type_id=:interval&ts_start=:from&ts_stop=:to",
      lastMinMaxPointsCount:
        "squaber/chart-data/last-min-max-points/:stockId/?interval_type_id=:interval&count=:count",
      currentLastMinMaxPoints:
        "squaber/chart-data/last-min-max-points/:stockId/?interval_type_id=:interval&current_only=true",
      insiderTransactionsMarkers:
        "squaber/chart-data/insiders-transactions/:stockId/?ts_start=:from&ts_stop=:to",
      insiderTransactionsMarkersCount:
        "squaber/chart-data/insiders-transactions/:stockId/?count=:count",
      simpleChartData: "squaber/chart_data/:stockId/7/?count=:count",
      manageFigures: "figures/manage/:stockId/:interval/?for_trading_view=1",
      userChartData: "squaber/trading_view_chart/:stockId/",
      searchAutocomplete:
        "stock/search/:query?exclude_index=true&currency=PLN&markets=gpw,nc",
      searchAutocompleteWithIndex: "stock/search/:query",
      searchAutocompletePortfolio:
        "stock/search/:query?exclude_index=true&currency=:currency",
      signal: "signal/tpsl-signals/?limit=:limit",
      stockAnalysis: "stock/stock-analysis/?limit=:limit",
      stockAnalysisFiltered:
        "stock/stock-analysis/?limit=:limit&stock__ticker=:ticker&stock__market=:market",
      stockPageAnalysisFiltered:
        "stock/stock-analysis/?limit=:limit&stock__ticker=:ticker&stock__market=:market&active=True&exclude_related_stocks=1",
      stockAnalysesFilteredByCategory:
        "stock/stock-analysis-categories/?stock__ticker=:ticker&stock__market=:market&active=True&exclude_related_stocks=1",
      stockPageSingleAnalyses:
        "stock/stock-analysis/?stock__ticker=:ticker&stock__market=:market&category=:category&active=True&exclude_related_stocks=1",
      insiderAnalysis: "stock/insider-analysis/?limit=:limit",
      insiderAnalysisFiltered:
        "stock/insider-analysis/?limit=:limit&stock__ticker=:ticker&stock__market=:market",
      stockPageInsiderAnalysisFiltered:
        "stock/insider-analysis/?limit=:limit&stock__ticker=:ticker&stock__market=:market&active=True&exclude_related_stocks=1",
      insiderAnalysesFilteredByCategory:
        "stock/insider-analysis-categories/?stock__ticker=:ticker&stock__market=:market&active=True&exclude_related_stocks=1",
      stockPageSingleInsiderAnalyses:
        "stock/insider-analysis/?stock__ticker=:ticker&stock__market=:market&category=:category&active=True&exclude_related_stocks=1",

      longTermSignal: "signal/long-term-signal/",
      reportDates: "stock/stock_report_dates/:stockId/",
      dividends: "financial_report/dividends/:stockId/",
      stock: "stock/get/:marketId/:stockId/"
    },
    indicators: {
      highsAndLows:
        "indicators/highs-and-lows/:stockId/?interval_type_id=:interval&ts_start=:from&ts_stop=:to",
      highsAndLowsCount:
        "indicators/highs-and-lows/:stockId/?interval_type_id=:interval&count=:count",
      currentHighsAndLows:
        "indicators/highs-and-lows/:stockId/?interval_type_id=:interval&current_only=true"
    },
    financialSituation: {
      stock: "financial_situation/stock/:stockId"
    },
    signal: {
      get: "signal/signal/:signalId/"
    },
    stockAnalysis: {
      get: "stock/stock-analysis/:stockAnalysisId/"
    },
    insiderStockAnalysis: {
      get: "stock/insider-analysis/:stockAnalysisId/"
    },
    subscriptionStatus: {
      get: "notifications/subscription_status/:stockId/",
      setDefault: "notifications/subscription_status/:category/:stockId/",
      setSpecific:
        "notifications/subscription_status/:category/:channel/:stockId/"
    },
    globalSubscriptionStatus: {
      get: "notifications/subscription_status/",
      setDefault: "notifications/subscription_status/:category/",
      setSpecific: "notifications/subscription_status/:category/:channel/"
    },
    notices: {
      get: "notices/stock/:stockId",
      save: "notices/:noticeId"
    },
    stockSeoData: {
      getSectionList: "seo/:marketId/",
      getSectionSeoData: "seo/:marketId/:stockId/:section",
      getMarketList: "seo/markets-languages"
    },
    priceAlerts: {
      add: "price_alerts/:stockId",
      get: "price_alerts/:stockId",
      delete: "price_alerts/:stockId/:alertId",
      tableConfig: "price_alerts/table/config/",
      tableWithOptions: "price_alerts/table/?:options"
    },
    payment: {
      details: "payment/details/",
      transactionHistory: "payment/history/",
      authorize: "payment/authorize/",
      release: "payment/release/",
      userOffer: "payment/user_offer/",
      offers: "payment/offers/?offer_id=:offerId"
    },
    plans: {
      offers: "plan/offers",
      forPermission: "plan/for-permission?permission=:permission"
    },
    payu: {
      create: "payu/create/"
    },
    bluemedia: {
      pretransaction: "bluemedia/pretransaction"
    },
    tradingView: {
      imageChart: "squaber/static_chart/:market/:ticker/:width?t=:time"
    },
    portfolio: {
      singlePortfolio: "portfolio/:id",
      chart:
        "portfolio/:portfolioId/chart/?count=:count&start=:start&cum_equity=1",
      rate_of_return_chart:
        "portfolio/:portfolioId/chart/?count=:count&start=:start",
      transactionHistory: "portfolio/:portfolioId/transaction/?limit=:limit",
      deleteTransaction: "portfolio/:portfolioId/transaction/:transactionId/",
      transaction: "portfolio/:portfolioId/transaction/",
      list: "portfolio/",
      aggregated:
        "portfolio/:portfolioId/aggregate/?market=:market&ticker=:ticker",
      cashOperations:
        "portfolio/:portfolioId/transaction/?model=cash_balance_change",
      transactionHistoryUniversalTable:
        "portfolio/:id/transaction/?model=:model&:options",
      stock: "portfolio/stock/:stockId",
      assets: "assets/?limit=:limit&offset=:offset",
      assetsFilteredByCurrency:
        "assets/?limit=:limit&offset=:offset&currency=:currency",
      assetPrices: "assets/:id/prices/?limit=:limit&offset=:offset",
      assetPricesUpload: "assets/:id/prices/upload",
      addAsset: "assets/",
      asset: "assets/:id/",
      assetsOperations:
        "portfolio/:portfolioId/transaction/?model=asset_transaction"
    },
    marketing: {
      bar: "marketing/bar/",
      messages: "marketing/messages/",
      skipMarketingMessage: "marketing/messages/:messageId/skip",
      acceptMarketingMessage: "marketing/messages/:messageId/accept"
    },
    faq: {
      questions: "faq/questions/"
    },
    config: {
      termsAndConditions: "config/termsAndConditions",
      cookiesPolicy: "config/cookiesPolicy",
      homeLandingPage: "config/landingPageUrl?string_val=1",
      offerUrl: "config/offerUrl?string_val=1",
      affiliationTermsAndConditions: "config/affiliationTermsAndConditions",
      affiliationTermsAndConditionsPdf:
        "config/affiliationTermsAndConditionsPdf?string_val=1",
      upcomingFeatures: "config/upcomingFeatures",
      changesHistory: "config/changesHistory"
    },
    mobile: {
      versionPolicy: "mobile/version-policy/"
    },
    contact: {
      send: "squaber/contact/"
    },
    csvData: {
      config: "csv_data/:id/",
      configWithSettings: "csv_data/:id/?:settings",
      tab: "csv_data/:id/tab/:tabId?limit=:limit",
      tabWithOptions: "csv_data/:id/tab/:tabId?:options",
      financialReport: {
        insiderTransactions: {
          config: "financial_report/insider-transactions-table-config",
          configWithSettings:
            "financial_report/insider-transactions-table-config?:settings",
          tab: "financial_report/insider-transactions-table?limit=:limit",
          tabWithOptions: "financial_report/insider-transactions-table?:options"
        }
      }
    },
    chartTemplates: {
      list: "squaber/chart-template/",
      singleTemplate: "squaber/chart-template/:id/",
      remove: "squaber/chart-template/:id"
    },
    chartAnalyses: {
      list: "squaber/stock/:stockId/chart-analysis/",
      update: "squaber/stock/:stockId/chart-analysis/:analysisId",
      remove: "squaber/stock/:stockId/chart-analysis/:analysisId"
    },
    tags: {
      tag: "stock/tags",
      tagsWithStocksInfo: "stock/tags?return_stocks=true",
      stockTags: "stock/tags?stock_id=:stockId&return_admin_tags=true",
      allTags: "stock/tags?return_stocks=true",
      allTagsWithLimit: "stock/tags?return_stocks=true&limit=:limit",
      allTagsWithQuery:
        "stock/tags?query=:query&return_admin_tags=true&return_stocks=true&limit=:limit",
      userTagsWithQuery: "stock/tags?query=:query&&limit=:limit",
      singleTag: "stock/tags/:id",
      tagToStockConnection: "stock/tags/:tagId/:stockId",
      allAvailableTags: "stock/tags?return_stocks=true&return_admin_tags=true"
    },
    partnership: {
      data: "partnership/?limit=:limit&offset=:offset"
    },
    affiliateProgram: {
      details: "program/",
      history: "program/event/history/",
      relation: "program/relation/",
      acceptRegulations: "program/agreement/"
    },
    browserView: {
      interestingStocks: "browser-view/interesting-stocks/?markets[]=:markets",
      interestingStocksNoMarkets: "browser-view/interesting-stocks/"
    },
    stripe: {
      createOrder: "stripe/create-order/",
      createCustomerPortalSession: "stripe/create-customer-portal-session/"
    },
    revenueCat: {
      relation: "revenue-cat/relation/"
    },
    strategies: {
      manual: "strategies/manual/",
      transaction: "strategies/transaction/",
      returnRateChart:
        "strategies/return-rate-chart/?strategy_type=:strategyType&timeframe=:timeframe:marketQuery"
    },
    sm: {
      event: "xYbNzHmIjK/sGpLwJqKtR"
    },
    staticPages: {
      list: "static-pages/",
      bySlug: "static-pages/by-slug/:slug",
      byId: "static-pages/:id",
      redirects: "static-pages/redirects/"
    },
    staticSeoData: {
      retrieve: "seo/pages/retrieve?slug=:slug"
    }
  },
  fe: {
    home: "",
    homeWithLocale: ":locale/",
    search: ":locale/search",
    login: ":locale/login",
    loginWithRedirect: ":locale/login?redirectTo=:redirectUrl",
    register: ":locale/register",
    registerWithRedirect: ":locale/register?redirectTo=:redirectUrl",
    loginOtp: ":locale/login-otp",
    resetPassword: ":locale/reset-password",
    stockPage: ":locale/:marketId/:stockId",
    stockPageSection: ":locale/:marketId/:stockId/:section",
    stockPageWithScrollToSection:
      ":locale/:marketId/:stockId?scroll_to_stock_page_section=:section",
    stockPageWithTvFullScreen:
      ":locale/:marketId/:stockId?tv_full_screen=true",
    // Deprecated: prefer stockPage / stockPageWithTvFullScreen.
    // Kept so existing /fullscreenchart bookmarks still resolve.
    fullScreenChart:
      ":locale/fullscreenchart/:marketId/:stockId?tv_full_screen=true",
    fullScreenChartWithReturnTo:
      ":locale/fullscreenchart/:marketId/:stockId?tv_full_screen=true&return_to=:returnTo",
    lightWeightChartPage: ":locale/lightweightchart/:stockId",
    paymentDetails: ":locale/payment-details",
    fullscreenIntercomPage:
      ":locale/fullscreen-intercom?user=:userDataQueryString",
    fullscreenIntercomPageAnonymous: ":locale/fullscreen-intercom",
    settingsPage: ":locale/settings",
    settingsPageCategory: ":locale/settings/:settingsCategory",
    settingsPageCategoryAfterPayment:
      ":locale/settings/:settingsCategory?after_payment=true",
    paymentForm: ":locale/payment-details/:offerId",
    offerCheckout: ":locale/offer-checkout/:offerId",
    paymentFormWithAutoLogin:
      ":locale/payment-details/:offerId?auth_token_for_login=:authToken&will_redirect_to_native_after_payment=true",
    portfolio: ":locale/portfolios/:id",
    portfoliosPage: ":locale/portfolios",
    interestingStocks: ":locale/analysis?category_id=4",
    portfoliosPageWithoutRedirect: ":locale/portfolios?no_redirect=true",
    faqQuestion: ":locale/faq/:questionId",
    myStocksAfterLogin: ":locale/my-stocks?after_login=true",
    tagsSettings: ":locale/settings/tags",
    tagsSettingsAddTag: ":locale/settings/tags/new",
    tagSettings: ":locale/settings/tags/tag/:id",
    otherAssetsSettings: ":locale/settings/other-assets",
    otherAssetsAddOtherAsset: ":locale/settings/other-assets/new-other-asset",
    otherAssetSettings: ":locale/settings/other-assets/other-asset/:id",
    desktopPage: ":locale/pulpit/",
    desktopPageAfterPayment: ":locale/pulpit/?after_payment=true",
    desktopPageWithTagId: ":locale/pulpit/:tagId",
    affiliateLink: ":locale/affiliate?value=:token",
    analysisList: ":locale/analysis",
    singleAnalysisPage: ":locale/analysis/:id",
    insiderAnalysisList: ":locale/analysis-insider",
    singleInsiderAnalysisPage: ":locale/analysis-insider/:id",
    manualStrategyPage: ":locale/manual-strategies/:id",
    turtleStrategySummary: ":locale/trend-following-strategy-signal-list",
    sidDashboard: ":locale/strategy/swing-and-direction",
    sidDashboardDescriptionTab: ":locale/strategy/swing-and-direction/description",
    sidDashboardTableTab: ":locale/strategy/swing-and-direction/table",
    sidDashboardSignalsTab: ":locale/strategy/swing-and-direction/signals",
    supplyDemandDashboard: ":locale/strategy/supply-and-demand-zones",
    supplyDemandDashboardDescriptionTab:
      ":locale/strategy/supply-and-demand-zones/description",
    supplyDemandDashboardTableTab: ":locale/strategy/supply-and-demand-zones/table",
    supplyDemandDashboardSignalsTab: ":locale/strategy/supply-and-demand-zones/signals",
    trendDashboard: ":locale/strategy/trend",
    trendDashboardDescriptionTab: ":locale/strategy/trend/description",
    trendDashboardSignalsTab: ":locale/strategy/trend/signals",
    privacyPolicy: ":locale/regulations/privacy-policy",
    plans: {
      mainPage: ":locale/plans",
      mainPageWithAutoLogin:
        ":locale/plans/?auth_token_for_login=:authToken&will_redirect_to_native_after_payment=true",
      availableInPlan: ":locale/plans/:id",
      availableInPlanWithPeriod: ":locale/plans/:id?period=:period",
      availableInPlanWithAutoLogin:
        ":locale/plans/:id?auth_token_for_login=:authToken&will_redirect_to_native_after_payment=true",
      successAfterPayment: ":locale/plans/success",
      errorAfterPayment: ":locale/plans/error"
    }
  },
  pl: {
    fe: {
      offerCheckout: ":locale/skorzystaj-z-oferty/:offerId",
      analysisList: ":locale/analizy",
      singleAnalysisPage: ":locale/analizy/:id",
      insiderAnalysisList: ":locale/analizy-insidera",
      singleInsiderAnalysisPage: ":locale/analizy-insidera/:id",
      sidDashboard: ":locale/strategie/szczyty-i-dna",
      sidDashboardDescriptionTab: ":locale/strategie/szczyty-i-dna/opis",
      sidDashboardTableTab: ":locale/strategie/szczyty-i-dna/tabela",
      sidDashboardSignalsTab: ":locale/strategie/szczyty-i-dna/sygnaly",
      supplyDemandDashboard: ":locale/strategie/strefy-popytu",
      supplyDemandDashboardDescriptionTab:
        ":locale/strategie/strefy-popytu/opis",
      supplyDemandDashboardTableTab: ":locale/strategie/strefy-popytu/tabela",
      supplyDemandDashboardSignalsTab: ":locale/strategie/strefy-popytu/sygnaly",
      trendDashboard: ":locale/strategie/trendowa",
      trendDashboardDescriptionTab: ":locale/strategie/trendowa/opis",
      trendDashboardSignalsTab: ":locale/strategie/trendowa/sygnaly"
    }
  },
  nativeSceneUrl: {
    home: ":locale/followed-stocks",
    followedStocksView: ":locale/followed-stocks",
    notifications: ":locale/notifications",
    userSettings: ":locale/settings/personal",
    settingsCategory: ":locale/settings/:settingsCategory",
    profile: ":locale/profile",
    profileHome: ":locale/profile",
    profileLogin: ":locale/login",
    profileRegister: ":locale/register",
    portfolios: ":locale/portfolios",
    portfolio: ":locale/portfolios/:id",
    menuHome: ":locale/menu",
    stocksTable: ":locale/stocks-table",
    interestingStocks: ":locale/interesting-stocks",
    analysis: ":locale/analysis",
    turtleStrategySummary: ":locale/trend-following-strategy-signal-list",
    sidDashboard: ":locale/strategy/swing-and-direction",
    supplyDemandDashboard: ":locale/strategy/supply-and-demand-zones",
    trendDashboard: ":locale/strategy/trend",
    longTermSignals: ":locale/long-term-signals",
    stockPage: ":locale/stock/:marketId/:stockId",
    fullscreenIntercom: ":locale/fullscreen-intercom",
    searchPage: ":locale/search",
    resetPassword: ":locale/reset-password"
  },
  urlToNativeSceneUrl: {
    "/:locale/payment-details/:id": "__noop",
    "/:locale/offer-checkout/:id": "__noop",
    "/:locale/skorzystaj-z-oferty/:id": "__noop",
    "/:locale/followed-stocks": "followedStocksView",
    "/:locale/pulpit/:id": "followedStocksView?defaultStocksListId=:id",
    "/:locale/notifications": "notifications",
    "/:locale/settings/personal": "userSettings",
    "/:locale/settings/:settingsCategory":
      "userSettings?defaultCategory=:settingsCategory",
    "/:locale/settings": "userSettings",
    "/:locale/profile": "profileHome",
    "/:locale/login": "profileLogin",
    "/:locale/register": "profileRegister",
    "/:locale/portfolios": "portfolios",
    "/:locale/portfolios/:id": "portfolio?id=:id",
    "/:locale/menu": "menuHome",
    "/:locale/stocks-table": "stocksTable",
    "/:locale/interesting-stocks": "interestingStocks",
    "/:locale/analysis": "analysesList",
    "/:locale/analizy": "analysesList",
    "/:locale/analysis/:id": "singleAnalysis?analysisId=:id",
    "/:locale/analizy/:id": "singleAnalysis?analysisId=:id",
    "/:locale/analysis-insider/:id":
      "singleAnalysis?analysisId=:id&isInsiderAnalysis=true",
    "/:locale/analizy-insidera/:id":
      "singleAnalysis?analysisId=:id&isInsiderAnalysis=true",
    "/:locale/trend-following-strategy-signal-list": "turtleStrategySummary",
    "/:locale/strategy/swing-and-direction": "sidDashboard",
    "/:locale/strategy/swing-and-direction/description": "sidDashboardDescription",
    "/:locale/strategy/swing-and-direction/table": "sidDashboardTable",
    "/:locale/strategy/swing-and-direction/signals": "sidDashboardSignals",
    "/:locale/strategie/szczyty-i-dna": "sidDashboard",
    "/:locale/strategie/szczyty-i-dna/opis": "sidDashboardDescription",
    "/:locale/strategie/szczyty-i-dna/tabela": "sidDashboardTable",
    "/:locale/strategie/szczyty-i-dna/sygnaly": "sidDashboardSignals",
    "/:locale/strategy/supply-and-demand-zones": "supplyDemandDashboard",
    "/:locale/strategy/supply-and-demand-zones/description":
      "supplyDemandDashboardDescription",
    "/:locale/strategy/supply-and-demand-zones/table": "supplyDemandDashboardTable",
    "/:locale/strategy/supply-and-demand-zones/signals": "supplyDemandDashboardSignals",
    "/:locale/strategie/strefy-popytu": "supplyDemandDashboard",
    "/:locale/strategie/strefy-popytu/opis": "supplyDemandDashboardDescription",
    "/:locale/strategie/strefy-popytu/tabela": "supplyDemandDashboardTable",
    "/:locale/strategie/strefy-popytu/sygnaly": "supplyDemandDashboardSignals",
    "/:locale/strategy/trend": "trendDashboard",
    "/:locale/strategy/trend/description": "trendDashboardDescription",
    "/:locale/strategy/trend/signals": "trendDashboardSignals",
    "/:locale/strategie/trendowa": "trendDashboard",
    "/:locale/strategie/trendowa/opis": "trendDashboardDescription",
    "/:locale/strategie/trendowa/sygnaly": "trendDashboardSignals",
    "/:locale/long-term-signals": "longTermSignals",
    "/:locale/plans/success": "__noop",
    "/:locale/plans/error": "__noop",
    "/:locale/plans/:id": "plans?availableInPlanId=:id",
    "/:locale/:marketId/:stockId":
      "stockPage?match[params][marketId]=:marketId&match[params][stockId]=:stockId",
    "/:locale/:marketId/:stockId/:section":
      "stockPage?match[params][marketId]=:marketId&match[params][stockId]=:stockId",
    "/:locale/search": "searchPage",
    "/:locale/reset-password": "resetPassword",
    "/:locale/plans": "plans",
    "/:locale/analizy-insidera": "insiderAnalysis",
    "/:locale/analysis-insider": "insiderAnalysis",
    "/:locale/insider-analysis": "insiderAnalysis",
    "/:locale/:slug": "genericStaticPage?slug=:slug"
  },
  fbTracker: {
    trackEvent: `https://graph.facebook.com/:appId/activities
      ?event=:event
      &custom_events=:customEvents
      &application_tracking_enabled=:applicationTrackingEnabled
      &advertiser_tracking_enabled=:advertiserTrackingEnabled
      &advertiser_id=:advertiserId
      &:clientToken`
  }
};
